import { Controller } from '@hotwired/stimulus'

const FIELD_NAME = 'autoarchive'

export default class extends Controller {
  static values = {
    isChecked: Boolean
  }

  declare isCheckedValue: boolean

  change(): void {
    this.isCheckedValue = !this.isCheckedValue

    // toggle query string boolean
    const currentUrl = new URL(window.location.href)
    currentUrl.searchParams.delete(FIELD_NAME)
    const newValue = this.isCheckedValue ? 'true' : 'false'
    currentUrl.searchParams.set(FIELD_NAME, newValue)

    window.location.href = currentUrl.href
  }
}
